<template>
  <div class="container">
    <div class="head">
      <img src="@/assets/back.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
      <div>我的求购</div>
      <div style="margin-right: 10px;color: #FE003B" @click="$router.push({path: '/mine/buy/history'})">历史求购信息</div>
    </div>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(index)" :class="activeTag==index ? 'active':''">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="table_box_big">
        <div class="table_box">
          <table class="table" border="0" width="100%"  style="table-layout:fixed">
            <!-- 表头 -->
            <thead>
            <tr>
              <th>*产品型号</th>
              <th>产品名称</th>
              <!--<th>产品封装</th>-->
              <th v-if="activeTag == 0">产品封装</th>
              <th v-if="activeTag != 0">产品规格</th>
              <th>品牌要求</th>
              <th>接受价格</th>
              <th>产品数量</th>
              <th>备注</th>
            </tr>
            </thead>
          </table>
          <div class="table_tbody_box">
            <table class="table"  border="0" width="100%" style="table-layout:fixed">
              <tbody v-for="(aa,index) in list" :key="index">
                <tr v-for="(item,index) in aa.purchaseItems" :key="index">
                  <td><page-input v-model="item.model" class="input"/></td>
                  <td><page-input v-model="item.name" class="input"/></td>
                  <td><page-input v-model="item.packages" class="input"/></td>
                  <td><page-input v-model="item.brand" class="input"/></td>
                  <td><page-input v-model="item.price" class="input"/></td>
                  <td><page-input v-model="item.number" class="input"/></td>
                  <td><page-input v-model="item.remark" class="input"/></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <div @click="$router.push('/mine/buy/buyImages?activeTag='+activeTag)" class="tup" style="margin-top: 30px;">
      <div class="tuptext">图片</div>
      <img src="@/assets/right.png" width="14" height="14" style="margin-top: 15px;margin-right: 12px;"/>
    </div>
    <div @click="$router.push('/mine/buy/showFile?activeTag='+activeTag)"  class="tup">
      <div class="tuptext">文件</div>
      <img src="@/assets/right.png" width="14" height="14" style="margin-top: 15px;margin-right: 12px;"/>
    </div>

    <div class="submit" @click="$router.push({path: '/purchase'})">我要求购</div>

  </div>
</template>

<script>
import { getShopPurchaseList } from '@/api/purchase/index.js'
export default {
  name: 'MyBuy',
  data() {
    return {
      show: false,
      activeTag: 0,
      tabList: ['电子元器件求购', '电子产品求购', '其他求购'],
      list:[]
    }
  },
  created() {
    this._getShopPurchaseList()
  },
  methods: {
    handleTag(index) {
      this.activeTag = index
      this._getShopPurchaseList()
    },

    _getShopPurchaseList() {
      var user = localStorage.getItem("userInfo")
      user = JSON.parse(user)
      const params = {
        type: this.activeTag,
        uid: user.id,
        // fileType: 2
      }
      getShopPurchaseList(params).then((res) => {
        if (res.success) {
          this.list = []
          res.data.forEach((item)=>{
            if (item.fileType == 2) {
              this.list.push(item)
            }
          })
        }
      })
    },

    go() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .head{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .main{
      padding: 0 12px;
      .table_box_big{
        overflow: scroll;
        width: 100%;
        /*overflow-x: scroll;*/
        /*overflow-y: hidden;*/
        position: relative;
        min-height: 100px;
        height: auto;
      }
      .table_box{
        /*overflow: hidden;*/
        /*position: absolute;*/
      }
      .table_tbody_box{
        /*height: 400px;*/
        /*overflow: scroll;*/
      }
      table thead tr th{
        width:100px;
        height:30px;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);

      }
      table tbody tr td{
        width:100px;
        height:30px;
        line-height: 30px;
        border: 1px solid #eeeeee;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);
        .input{
          width:80px;
          border: none;
        }
      }

    }
    .submit{
      position: fixed;
      right: 12px;
      bottom: 12px;
      left: 12px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
      opacity:1;
      border-radius:4px;
    }
    .tup{
      height: 50px;
      display: flex;
      justify-content: space-between;
      border-top: 2px solid #EDEDED;
      .tuptext{
        font-size:16px;
        font-family:PingFang SC;
        line-height: 50px;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin-left: 12px;
        opacity:1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/buy/myBuy.vue